import React, { useState } from 'react';
import VoxelAutocomplete from '../../../components/voxel/Forms/VoxelAutocomplete';
import VoxelCheckbox from '../../../components/voxel/Forms/VoxelCheckbox';
import VoxelComboBox from '../../../components/voxel/Forms/VoxelComboBox';
import VoxelInput from '../../../components/voxel/Forms/VoxelInput';
import VoxelSelect from '../../../components/voxel/Forms/VoxelSelect';
import VoxelTextarea from '../../../components/voxel/Forms/VoxelTextArea';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import VoxelSwitch from '../../../components/voxel/Forms/VoxelSwitch';
import VoxelRadio from '../../../components/voxel/Forms/VoxelRadio';
import VoxelFormPanelActionCancel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionCancel';
import VoxelAlert from '../../../components/voxel/Alert/VoxelAlert';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';

export interface FormsBoardProps { }

export const FormsBoard: React.FC<FormsBoardProps> = ({ }) => {
  // States
  const [checked, setChecked] = useState<boolean>(true);
  const [comboBoxInput, setComboBoxInput] = useState('');

  return (
    <div className="flex flex-row gap-6">
      <div className="basis-1/2 grow flex flex-col gap-6">
        <VoxelFormPanel
          title={<>With label at the top</>}
          subtitle={
            <>
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
              unknown printer took a galley of type and scrambled it to make a type specimen book.
            </>
          }
        >
          <VoxelFormPanelContent className="">
            <div className="col-span-2">
              <VoxelInput
                id={'input'}
                label={'Input'}
                labelPosition={'top'}
                placeholder={'placeholder'}
                helperText={'Field submit error'}
                showHelperText={false}
                deleteValue={function (): void {
                  throw new Error('Function not implemented.');
                }}
                maxLength={0}
              />
            </div>
            <div className="">
              <VoxelSelect
                id={'select'}
                label={'Select'}
                labelPosition={'top'}
                placeholder={'none'}
                options={['SWE', 'US', 'UK'].map((v) => ({ title: v, value: v }))}
                setSelectedOption={() => { }}
              />
            </div>
            <div className="">
              <VoxelAutocomplete
                id={'autocomplete'}
                label={'Autocomplete'}
                labelPosition={'top'}
                placeholder={'placeholder'}
                options={['SWE', 'US', 'UK'].map((v) => ({ title: v, value: v }))}
                setSelectedOptions={() => []}
                freeAdd
              />
            </div>
            <div className="col-span-2">
              <VoxelComboBox
                options={['äpple', 'apa', 'kaka']}
                label="ComboBox"
                labelPosition="top"
                value={comboBoxInput}
                setValue={setComboBoxInput}
              />
            </div>
            <div className="col-span-2">
              <VoxelTextarea
                id={'textarea'}
                label="Text area"
                value={''}
                placeholder={'Textarea placeholder'}
                minRows={0}
                maxLength={0}
                helperText={''}
                showHelperText={false}
              />
            </div>
          </VoxelFormPanelContent>
          <VoxelPanelActions>
            <VoxelFormPanelActionCancel />
            <VoxelFormPanelActionSubmit />
          </VoxelPanelActions>
        </VoxelFormPanel>
        <VoxelFormPanel title={<>Disabled</>} disabled>
          <VoxelFormPanelContent>
            <div className="col-span-2">
              <VoxelInput
                id={'input'}
                label={'Input'}
                labelPosition={'top'}
                placeholder={'placeholder'}
                helperText={'Field submit error'}
                showHelperText={false}
                deleteValue={function (): void {
                  throw new Error('Function not implemented.');
                }}
                maxLength={0}
                disabled
              />
            </div>
            <div className="">
              <VoxelSelect
                id={'select'}
                label={'Select'}
                labelPosition={'top'}
                placeholder={'none'}
                options={['SWE', 'US', 'UK'].map((v) => ({ title: v, value: v }))}
                setSelectedOption={() => { }}
                disabled
              />
            </div>
            <div className="">
              <VoxelAutocomplete
                id={'autocomplete'}
                label={'Autocomplete'}
                labelPosition={'top'}
                placeholder={'placeholder'}
                options={['SWE', 'US', 'UK'].map((v) => ({ title: v, value: v }))}
                setSelectedOptions={() => []}
                freeAdd
                disabled
              />
            </div>
            <div className="col-span-2">
              <VoxelComboBox
                options={['äpple', 'apa', 'kaka']}
                label="ComboBox"
                labelPosition="top"
                value={comboBoxInput}
                setValue={setComboBoxInput}
                disabled
              />
            </div>
            <div className="col-span-2">
              <VoxelTextarea
                id={'textarea'}
                label="Text area"
                value={''}
                placeholder={'Textarea placeholder'}
                minRows={0}
                maxLength={0}
                helperText={''}
                showHelperText={false}
                disabled
              />
            </div>
          </VoxelFormPanelContent>
          <VoxelAlert size="sm" roundedClass={'rounded-t-none'} iconSize="lg" iconPosition="center">
            This form is currently disabled because...{' '}
          </VoxelAlert>
        </VoxelFormPanel>
      </div>
      <div className="basis-1/2 flex flex-col gap-6 grow-0">
        <VoxelFormPanel title={<>Sizes</>}>
          <VoxelFormPanelContent className="gap-6">
            <div className="w-full flex flex-row gap-6 flex-nowrap ">
              <div className="grow basis-2/5">
                <VoxelInput
                  id={'autocomplete'}
                  label={'Input'}
                  labelPosition={'left'}
                  placeholder={'placeholder'}
                  value={''}
                />
              </div>
              <div className="basis-2/5">
                <VoxelSelect
                  id={'select'}
                  label={'Select'}
                  labelPosition={'left'}
                  placeholder={'none'}

                  options={['SWE', 'US', 'UK'].map((v) => ({ title: v, value: v }))}
                  setSelectedOption={() => { }}
                />
              </div>
              <VoxelFormPanelActionSubmit />
            </div>
            <div className="w-full flex flex-row gap-6 flex-nowrap ">
              <div className="grow basis-2/5">
                <VoxelInput
                  id={'autocomplete'}
                  label={'Input'}
                  labelPosition={'left'}
                  placeholder={'placeholder'}

                  value={''}
                  size="sm"
                />
              </div>
              <div className="basis-2/5">
                <VoxelSelect
                  id={'select'}
                  label={'Select'}
                  labelPosition={'left'}
                  placeholder={'none'}
                  options={['SWE', 'US', 'UK'].map((v) => ({ title: v, value: v }))}
                  setSelectedOption={() => { }}
                  size="sm"

                />
              </div>
              <VoxelFormPanelActionSubmit size="md" />
            </div>
          </VoxelFormPanelContent>
        </VoxelFormPanel>
        <VoxelFormPanel title={<>Checkboxes</>}>
          <VoxelFormPanelContent>
            <div className="flex flex-col gap-6">
              <VoxelCheckbox
                label={
                  <div className="pl-1">
                    <div className="text-sm">This is a checkbox title</div>
                    <div className="text-xs text-voxel-gray-500 ml-0.5">
                      A subtitle can be added if the option needs to be explained more.
                    </div>
                  </div>
                }
                checked={checked}
                onChange={() => setChecked(!checked)}
                padding
              />
              <div className="flex flex-row items-center gap-8">
                <VoxelText className="">Square</VoxelText>
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  color="primary"
                  padding
                  label="Primary"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  color="outlined"
                  padding
                  label="Outlined"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  color="slate"
                  padding
                  label="Slate"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  color="emerald"
                  padding
                  label="Emerald"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  color="indigo"
                  padding
                  label="Indigo"
                />
              </div>
              <div className="flex flex-row items-center gap-8">
                <VoxelText className="">Rounded</VoxelText>
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  padding
                  color="primary"
                  shape="circle"
                  label="Primary"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  padding
                  color="outlined"
                  shape="circle"
                  label="Outlined"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  padding
                  color="slate"
                  shape="circle"
                  label="Slate"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  padding
                  color="emerald"
                  shape="circle"
                  label="Emerald"
                />
                <VoxelCheckbox
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  padding
                  color="indigo"
                  shape="circle"
                  label="Indigo"
                />
              </div>

              <div className="flex flex-row items-center gap-12">
                <VoxelText className="">Switches</VoxelText>
                <VoxelSwitch
                  value={checked}
                  onChange={() => setChecked(!checked)}
                  color="primary"
                  title="Primary"
                />
                <VoxelSwitch
                  value={checked}
                  onChange={() => setChecked(!checked)}
                  color="slate"
                  title="Slate"
                />
                <VoxelSwitch
                  value={checked}
                  onChange={() => setChecked(!checked)}
                  color="emerald"
                  title="Emerald"
                  onLabel="On"
                  offLabel="Off"
                />
                <VoxelSwitch
                  value={checked}
                  onChange={() => setChecked(!checked)}
                  color="indigo"
                  title="Indigo"
                />
              </div>
              <div className="flex flex-row items-center gap-12">
                <VoxelText className="pr-2">Radios</VoxelText>
                <VoxelRadio
                  title={''}
                  value={''}
                  selectedOption={''}
                  setSelectedOption={function (value: React.SetStateAction<string | number>): void {
                    throw new Error('Function not implemented.');
                  }}
                />
              </div>
            </div>
          </VoxelFormPanelContent>
        </VoxelFormPanel>
      </div>
    </div>
  );
};

export default FormsBoard;
